import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check if user is already logged in
    const userData = localStorage.getItem('czoneUser');
    if (userData) {
      navigate('/dashboard');
    }
  }, [navigate]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }
    
    if (isSignUp && !email.trim()) {
      setError('Please enter your email');
      return;
    }
    
    if (isSignUp && !validateEmail(email)) {
      setError('Please enter a valid email');
      return;
    }
    
    // Create user object
    const user = {
      id: `user-${Date.now()}`,
      name: name.trim(),
      email: isSignUp ? email.trim() : '',
      avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(name.trim())}&background=random`
    };
    
    // Save user data to local storage
    localStorage.setItem('czoneUser', JSON.stringify(user));
    
    // Navigate to dashboard
    navigate('/dashboard');
  };
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="czone-logo">
            <img src="/cdezone_logo.jpg" alt="CZone Logo" width="150" />
          </div>
          <h1>Welcome to CZone</h1>
          <p>Sign in to continue</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>
          
          {isSignUp && (
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
          )}
          
          <button type="submit" className="login-button">
            {isSignUp ? 'Sign Up' : 'Login'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>
            {isSignUp ? 'Already have an account?' : 'Don\'t have an account?'}
            <button
              className="toggle-form-btn"
              onClick={() => setIsSignUp(!isSignUp)}
            >
              {isSignUp ? 'Login' : 'Sign Up'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
